export const createChatWindowTourSteps = (that) => {
    return [];
};
